import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UnauthorizedComponent } from "./unauthorized/unauthorized.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { SidebarLayoutComponent } from "./sidebar-layout/sidebar-layout.component";
import { SampleResultComponent } from "../components/sample-result/sample-result.component";
import { NodeDetailsPopupComponent } from "./node-details-popup/node-details-popup.component";
import { MapMarkerComponent } from "./map-marker/map-marker.component";
import { ExposureBySegsPopupComponent } from "./main/exposure-by-segs-popup/exposure-by-segs-popup.component";
import { ExposureByTaskComponent } from "./main/exposure-by-task/exposure-by-task.component";
import { ExposureByTaskGroupComponent } from "./main/exposure-by-task-group/exposure-by-task-group.component";
import { ExposureContributionByTaskGroupComponent } from "./main/exposure-contribution-by-task-group/exposure-contribution-by-task-group.component";
import { ExposureReductionPlanItemsComponent } from "./main/exposure-reduction-plan-items/exposure-reduction-plan-items.component";
import { ExposureReductionPlanStatusComponent } from "./main/exposure-reduction-plan-status/exposure-reduction-plan-status.component";
import { ExposuresBySegsComponent } from "./main/exposures-by-segs/exposures-by-segs.component";
import { SegDetailsComponent } from "./main/seg-details/seg-details.component";
import { ExposureInLocationComponent } from "./main/seg-details/exposure-in-location/exposure-in-location.component";
import { ExposureByChartComponent } from "./main/seg-details/exposure-by-chart/exposure-by-chart.component";
import { ControlHistoryComponent } from "./main/seg-details/control-history/control-history.component";
import { ContributionToExposuresComponent } from "./main/seg-details/contribution-to-exposures/contribution-to-exposures.component";
import { HeaderComponent } from "./header/header.component";
import { GravimetricResultsComponent } from "./sample-details/gravimetric-results/gravimetric-results.component";
import { GoogleMapsComponent } from "./google-maps/google-maps.component";
import { MapLibreRealtimeMapComponent } from "./maplibre-realtime-map/maplibre-realtime-map.component";
import { ExtendedMapOptionsComponent } from "./extended-map-options/extended-map-options.component";
import { CustomPaginationComponent } from "./custom-pagination/custom-pagination.component";
import { SharedModule } from "../shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { CommentsNotesComponent } from "./sample-details/comments-notes/comments-notes.component";
import { ExposureGraphComponent } from "./sample-details/exposure-graph/exposure-graph.component";
import { ExposureContributionsComponent } from "./sample-details/exposure-contributions/exposure-contributions.component";
import { EditCommentComponent } from "./sample-details/edit-comment/edit-comment.component";
import { WorkerExposuresComponent } from "./main/worker-exposures/worker-exposures.component";
import { ExposureByLocationGroupComponent } from "./main/exposure-by-location-group/exposure-by-location-group.component";
import { GroupAssociatedSegsComponent } from "./main/exposure-by-task-group/group-associated-segs/group-associated-segs.component";
import { GroupTaskDistributionComponent } from "./main/exposure-by-task-group/group-task-distribution/group-task-distribution.component";
import { GroupTaskSamplesComponent } from "./main/exposure-by-task-group/group-task-samples/group-task-samples.component";
import { ChartHeaderComponent } from "../components/chart-header/chartHeader.component";
import { TaskReportComponent } from "./main/exposure-by-task/task-report/task-report.component";
import { AssociatedSegsComponent } from "./main/exposure-by-task/associated-segs/associated-segs.component";
import { TaskDistributionComponent } from "./main/exposure-by-task/task-distribution/task-distribution.component";
import { TaskSamplesComponent } from "./main/exposure-by-task/task-samples/task-samples.component";
import { LazyVideoPlayerComponent } from "./lazy-video-player/lazy-video-player.component";
import { OrgTreeSelectComponent } from "../shared/org-tree-select/org-tree-select.component";
import { CopyrightComponent } from "./copyright/copyright.component";
import { RiskRegistersReportPopupComponent } from './risk-registers-report-popup/risk-registers-report-popup.component';
import { ParameterThresholdEditorComponent } from './parameter-threshold-editor/parameter-threshold-editor.component';
import { RiskAssessmentReportPopupComponent } from './risk-assessment-report-popup/risk-assessment-report-popup.component';
import { FLYOUT_DATA } from "../shared/flyout/flyout-container/flyout-data.token";
import { CommentsDialogComponent } from './comments-dialog/comments-dialog.component';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { TranslateModule } from "@ngx-translate/core";
import { AgentDetailsPopupComponent } from './agent-details-popup/agent-details-popup.component';
import { JurisdictionDetailsPopupComponent } from './jurisdiction-details-popup/jurisdiction-details-popup.component';
import { ControlDetailsPopupComponent } from './control-details-popup/control-details-popup.component';
import { SampleMediaDetailsPopupComponent } from "./sample-media-details-popup/sample-media-details-popup.component";
import { AnalyticalMethodDetailsPopupComponent } from "./analytical-method-details-popup/analytical-method-details-popup.component";
import { LabRequisitionDetailsPopupComponent } from './lab-requisition-details-popup/lab-requisition-details-popup.component';
import { SampleDetailsComponent } from "../components/sample-details/sample-details.component";
import { SampleSurveyDetailsComponent } from "../components/sample-survey-details/sample-survey-details.component";
import { GenerateCocPopupComponent } from './generate-coc-popup/generate-coc-popup.component';
import { ReportGenerationPopupComponent } from "../components/report-generation-popup/report-generation-popup.component";
import { CalibrationDetailsComponent } from "../components/calibration-details/calibration-details.component";
import { CalibrationMaintenanceHistoryComponent } from "../components/calibration-maintenance-history/calibration-maintenance-history.component";
import { RiskTreatmentReportComponent } from './risk-treatment-report/risk-treatment-report.component';
import { AgentGroupDetailsPopupComponent } from './agent-group-details-popup/agent-group-details-popup.component';
import { TaskGroupDetailsPopupComponent } from './task-group-details-popup/task-group-details-popup.component';
import { SegDetailsPopupComponent } from './seg-details-popup/seg-details-popup.component';
import { SegOrgLevelHistoryComponent } from './seg-org-level-history/seg-org-level-history.component';
import { FieldOutOfRangePipe } from './seg-details-popup/field-out-of-range.pipe';
import { JurisdictionRiskConfigFormComponent } from './jurisdiction-risk-config-form/jurisdiction-risk-config-form.component';
import { RiskConfigLegendComponent } from './risk-config-legend/risk-config-legend.component';
import { SampleValidationRulesFormComponent } from './sample-validation-rules-form/sample-validation-rules-form.component';
import { ColorPickerDirective } from "ngx-color-picker";
import { MatIconModule } from "@angular/material/icon";
import { PasswordCriteriaComponent } from "./password-criteria/password-criteria.component";
import { CocSampleGridComponent } from './coc-sample-grid/coc-sample-grid.component';
import { SeverityChipComponent } from './severity-chip/severity-chip.component';
import { NotificationCenterComponent } from '../components/notification-center/notification-center.component';
import { TemplateShareControlComponent } from './template-share-control/template-share-control.component';
import { TemplateShareControlDialogComponent } from './template-share-control/template-share-control-dialog.component';
import { TemplateSaveDialogComponent } from './template-save-dialog/template-save-dialog.component';
import { AngularResizeEventModule } from 'angular-resize-event-package';

@NgModule({
  declarations: [
    UnauthorizedComponent,
    SidenavComponent,
    SidebarLayoutComponent,
    SampleResultComponent,
    NodeDetailsPopupComponent,
    MapMarkerComponent,
    ExposureBySegsPopupComponent,
    ExposureByTaskComponent,
    ExposureByTaskGroupComponent,
    ExposureContributionByTaskGroupComponent,
    ExposureReductionPlanItemsComponent,
    ExposureReductionPlanStatusComponent,
    ExposuresBySegsComponent,
    SegDetailsComponent,
    ExposureInLocationComponent,
    ExposureByChartComponent,
    ControlHistoryComponent,
    ContributionToExposuresComponent,
    HeaderComponent,
    GravimetricResultsComponent,
    GoogleMapsComponent,
    MapLibreRealtimeMapComponent,
    ExtendedMapOptionsComponent,
    CustomPaginationComponent,
    CommentsNotesComponent,
    ExposureGraphComponent,
    ExposureContributionsComponent,
    EditCommentComponent,
    WorkerExposuresComponent,
    ExposureByLocationGroupComponent,
    AssociatedSegsComponent,
    GroupAssociatedSegsComponent,
    TaskDistributionComponent,
    GroupTaskDistributionComponent,
    TaskSamplesComponent,
    GroupTaskSamplesComponent,
    ChartHeaderComponent,
    TaskReportComponent,
    CopyrightComponent,
    RiskRegistersReportPopupComponent,
    RiskAssessmentReportPopupComponent,
    CommentsDialogComponent,
    LocationPickerComponent,
    AgentDetailsPopupComponent,
    JurisdictionDetailsPopupComponent,
    SampleMediaDetailsPopupComponent,
    AnalyticalMethodDetailsPopupComponent,
    LabRequisitionDetailsPopupComponent,
    SampleDetailsComponent,
    SampleSurveyDetailsComponent,
    GenerateCocPopupComponent,
    CalibrationDetailsComponent,
    CalibrationMaintenanceHistoryComponent,
    ControlDetailsPopupComponent,
    RiskTreatmentReportComponent,
    AgentGroupDetailsPopupComponent,
    SegDetailsPopupComponent,
    JurisdictionRiskConfigFormComponent,
    CocSampleGridComponent,
    ParameterThresholdEditorComponent,
    SeverityChipComponent,
    NotificationCenterComponent,
    TemplateShareControlComponent,
    TemplateShareControlDialogComponent,
    TaskGroupDetailsPopupComponent,
    SampleValidationRulesFormComponent,
    SegOrgLevelHistoryComponent,
    TemplateSaveDialogComponent,
    PasswordCriteriaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    SharedModule,
    TranslateModule,
    ColorPickerDirective,
    MatIconModule,
    ReportGenerationPopupComponent,
    LazyVideoPlayerComponent,
    OrgTreeSelectComponent,
    RiskConfigLegendComponent,
    FieldOutOfRangePipe,
    AngularResizeEventModule,
    RouterLinkActive
  ],
  providers: [
    { provide: FLYOUT_DATA, useValue: {} }
  ],
  exports: [
    UnauthorizedComponent,
    SidenavComponent,
    SidebarLayoutComponent,
    SampleResultComponent,
    NodeDetailsPopupComponent,
    MapMarkerComponent,
    ExposureBySegsPopupComponent,
    ExposureByTaskComponent,
    ExposureByTaskGroupComponent,
    ExposureContributionByTaskGroupComponent,
    ExposureReductionPlanItemsComponent,
    ExposureReductionPlanStatusComponent,
    ExposuresBySegsComponent,
    SegDetailsComponent,
    ExposureInLocationComponent,
    ExposureByChartComponent,
    ControlHistoryComponent,
    ContributionToExposuresComponent,
    HeaderComponent,
    GravimetricResultsComponent,
    GoogleMapsComponent,
    MapLibreRealtimeMapComponent,
    ExtendedMapOptionsComponent,
    CustomPaginationComponent,
    CommentsNotesComponent,
    ExposureGraphComponent,
    ExposureContributionsComponent,
    EditCommentComponent,
    WorkerExposuresComponent,
    ExposureByLocationGroupComponent,
    AssociatedSegsComponent,
    GroupAssociatedSegsComponent,
    TaskDistributionComponent,
    GroupTaskDistributionComponent,
    TaskSamplesComponent,
    GroupTaskSamplesComponent,
    ChartHeaderComponent,
    TaskReportComponent,
    CopyrightComponent,
    RiskRegistersReportPopupComponent,
    RiskAssessmentReportPopupComponent,
    LocationPickerComponent,
    CommentsDialogComponent,
    AgentDetailsPopupComponent,
    JurisdictionDetailsPopupComponent,
    SampleMediaDetailsPopupComponent,
    AnalyticalMethodDetailsPopupComponent,
    LabRequisitionDetailsPopupComponent,
    SampleDetailsComponent,
    SampleSurveyDetailsComponent,
    GenerateCocPopupComponent,
    CalibrationDetailsComponent,
    CalibrationMaintenanceHistoryComponent,
    LazyVideoPlayerComponent,
    ControlDetailsPopupComponent,
    RiskTreatmentReportComponent,
    AgentGroupDetailsPopupComponent,
    SegDetailsPopupComponent,
    JurisdictionRiskConfigFormComponent,
    RiskConfigLegendComponent,
    CocSampleGridComponent,
    ParameterThresholdEditorComponent,
    SeverityChipComponent,
    TemplateShareControlComponent,
    TemplateShareControlDialogComponent,
    TaskGroupDetailsPopupComponent,
    SampleValidationRulesFormComponent,
    TemplateSaveDialogComponent,
    PasswordCriteriaComponent
  ],
})
export class CommonComponentsModule { }
